import MyNewsDeskItemPage from './MyNewsDeskItemPage';

export default MyNewsDeskItemPage;
